const copiedMoneyFormatter = new Intl.NumberFormat("es-AR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  useGrouping: true,
});

function parseMoneyString(value) {
  const trimmed = String(value || "").trim();
  if (!trimmed) return Number.NaN;
  const negative = /^\s*-/.test(trimmed) || /^\s*\(/.test(trimmed);
  let normalized = trimmed
    .replace(/[^\d,.-]/g, "")
    .replace(/-/g, "");
  if (!/\d/.test(normalized)) return Number.NaN;
  const lastComma = normalized.lastIndexOf(",");
  const lastDot = normalized.lastIndexOf(".");

  if (lastComma >= 0 && lastDot >= 0) {
    normalized = lastComma > lastDot
      ? normalized.replace(/\./g, "").replace(",", ".")
      : normalized.replace(/,/g, "");
  } else if (lastComma >= 0) {
    normalized = normalized.replace(/\./g, "").replace(",", ".");
  } else if (lastDot >= 0) {
    const parts = normalized.split(".");
    const groupedThousands = parts.length > 1
      && parts.slice(1).every((part) => part.length === 3);
    if (groupedThousands) normalized = parts.join("");
  }

  const parsed = Number(normalized);
  return negative ? -parsed : parsed;
}

export function formatMoneyForCopy(value) {
  const numeric = typeof value === "number" ? value : parseMoneyString(value);
  if (!Number.isFinite(numeric)) return "";
  return copiedMoneyFormatter.format(numeric);
}
